import { useIntl } from "react-intl";

import { useCohort } from "@/components/user-context";

import { LoggedInJsmExistingUser } from "./existing-user";
import { LoggedInJsmNewUser } from "./new-user";

export const LoggedInJsmFree = ({
    shouldForceOverlayView
}: {
    shouldForceOverlayView?: boolean;
}) => {
    const { formatMessage } = useIntl();
    const cohort = useCohort();

    if (cohort === "new-user") {
        return (
            <LoggedInJsmNewUser
                shouldForceOverlayView={shouldForceOverlayView}
            />
        );
    }

    if (cohort) {
        return (
            <LoggedInJsmExistingUser
                shouldForceOverlayView={shouldForceOverlayView}
                productEditionText={formatMessage({
                    id: "WacSignupHeader.cloudFree",
                    defaultMessage: "Cloud Free"
                })}
            />
        );
    }

    return null;
};
